const dashboard = {
  en: {
    greetingMorning: 'Good morning',
    greetingAfternoon: 'Good afternoon',
    greetingEvening: 'Good evening',
    heroSubtitle: "Here's how your courses are performing.",
    staffSubtitle: 'Your tasks for today and how your students are doing.',
    selectPeriod: 'Select period',
    createCourse: 'Create course',
    welcome: {
      title: 'Welcome to Darsly CRM',
      subtitle: "Let's get your first course live. Here's everything you'll do — it takes just a few minutes.",
      cta: 'Create your first course',
      step1Desc: 'Give it a title, level, and price.',
      step2Title: 'Build your curriculum',
      step2Desc: 'Add modules, lessons, and videos.',
      step3Title: 'Add a quiz or test',
      step3Desc: 'Check what your students have learned.',
      step4Title: 'Publish your course',
      step4Desc: 'Make it live so students can enroll.',
      step5Title: 'Enroll your first students',
      step5Desc: 'Invite learners and track their progress.',
    },
    periods: {
      d7: '7 days', d30: '30 days', d90: '90 days', y1: '1 year',
    },
    quickActions: {
      title: 'Quick links',
      courses: { label: 'Courses', desc: 'Manage your catalogue' },
      students: { label: 'Students', desc: 'Roster and results' },
      sales: { label: 'Sales', desc: 'Orders' },
      inbox: { label: 'Inbox', desc: 'Messages and feedback' },
      support: { label: 'Support', desc: 'Tickets and replies' },
      calendar: { label: 'Calendar', desc: 'Events and reminders' },
    },
    metrics: {
      students: { title: 'Paying students', change: 'All time' },
      orders: { title: 'Orders', change: 'Completed, all time' },
      revenue: { title: 'Revenue', change: 'UZS, all time' },
      courses: { title: 'Courses', change: 'In your account' },
    },
    pulse: {
      title: 'Students right now',
      total: '{count} students in total',
      updated: 'Updated {time}',
      tashkentTime: 'Tashkent time',
      openDirectory: 'Open the directory',
      onlineNow: 'Online now',
      activeToday: 'Active today',
      inactive7d: 'Inactive 7+ days',
      atRisk: 'At risk',
    },
    revenueOverview: 'Revenue',
    revenueSub: 'Completed sales',
    revenueError: "Couldn't load the revenue chart",
    emptyRevenue: {
      title: 'No revenue yet for this period',
      desc: 'Pick another period or wait for new orders to come in.',
    },
    topCourses: 'Top courses',
    topCoursesDesc: 'By revenue',
    viewAll: 'View all',
    noRevenueData: 'No revenue data yet.',
    untitledCourse: 'Untitled course',
    recentActivity: 'Recent orders',
    viewAllOrders: 'All orders',
    table: {
      student: 'Student', when: 'Date', amount: 'Amount', status: 'Status',
    },
    provider: { PAYCOM: 'Payme', CLICK: 'Click' },
    emptyOrders: {
      title: 'No recent orders',
      desc: 'New orders will appear here automatically.',
    },
  },
  ru: {
    greetingMorning: 'Доброе утро',
    greetingAfternoon: 'Добрый день',
    greetingEvening: 'Добрый вечер',
    heroSubtitle: 'Вот как работают ваши курсы.',
    staffSubtitle: 'Ваши задачи на сегодня и состояние студентов.',
    selectPeriod: 'Выберите период',
    createCourse: 'Создать курс',
    welcome: {
      title: 'Добро пожаловать в Darsly CRM',
      subtitle: 'Давайте запустим ваш первый курс. Вот что вам нужно сделать — это займёт всего пару минут.',
      cta: 'Создайте свой первый курс',
      step1Desc: 'Укажите название, уровень и цену.',
      step2Title: 'Создайте учебную программу',
      step2Desc: 'Добавьте модули, уроки и видео.',
      step3Title: 'Добавьте викторину или тест',
      step3Desc: 'Проверьте, что усвоили ваши студенты.',
      step4Title: 'Опубликуйте курс',
      step4Desc: 'Сделайте его доступным, чтобы студенты могли записаться.',
      step5Title: 'Запишите первых студентов',
      step5Desc: 'Пригласите учащихся и отслеживайте их прогресс.',
    },
    periods: {
      d7: '7 дней', d30: '30 дней', d90: '90 дней', y1: '12 мес.',
    },
    quickActions: {
      title: 'Быстрые ссылки',
      courses: { label: 'Курсы', desc: 'Управляйте каталогом' },
      students: { label: 'Студенты', desc: 'Список и результаты' },
      sales: { label: 'Продажи', desc: 'Заказы' },
      inbox: { label: 'Входящие', desc: 'Сообщения и отзывы' },
      support: { label: 'Поддержка', desc: 'Обращения и ответы' },
      calendar: { label: 'Календарь', desc: 'События и напоминания' },
    },
    metrics: {
      students: { title: 'Платящие студенты', change: 'За всё время' },
      orders: { title: 'Заказы', change: 'Завершённые, за всё время' },
      revenue: { title: 'Доход', change: 'В сумах, за всё время' },
      courses: { title: 'Курсы', change: 'В вашем аккаунте' },
    },
    pulse: {
      title: 'Студенты сейчас',
      total: 'Всего студентов: {count}',
      updated: 'Обновлено в {time}',
      tashkentTime: 'время Ташкента',
      openDirectory: 'Открыть справочник',
      onlineNow: 'Сейчас онлайн',
      activeToday: 'Активны сегодня',
      inactive7d: 'Неактивны 7+ дней',
      atRisk: 'В зоне риска',
    },
    revenueOverview: 'Доход',
    revenueSub: 'Завершённые продажи',
    revenueError: 'Не удалось загрузить график дохода',
    emptyRevenue: {
      title: 'За этот период доходов пока нет',
      desc: 'Выберите другой период или дождитесь новых заказов.',
    },
    topCourses: 'Лучшие курсы',
    topCoursesDesc: 'По доходу',
    viewAll: 'Все курсы',
    noRevenueData: 'Данных о доходах пока нет.',
    untitledCourse: 'Курс без названия',
    recentActivity: 'Недавние заказы',
    viewAllOrders: 'Все заказы',
    table: {
      student: 'Студент', when: 'Дата', amount: 'Сумма', status: 'Статус',
    },
    provider: { PAYCOM: 'Payme', CLICK: 'Click' },
    emptyOrders: {
      title: 'Нет недавних заказов',
      desc: 'Новые заказы будут появляться здесь автоматически.',
    },
  },
  uz: {
    greetingMorning: 'Xayrli tong',
    greetingAfternoon: 'Xayrli kun',
    greetingEvening: 'Xayrli kech',
    heroSubtitle: "Kurslaringiz qanday ishlayotganini ko'ring.",
    staffSubtitle: "Bugungi vazifalaringiz va o'quvchilar holati.",
    selectPeriod: 'Davrni tanlang',
    createCourse: 'Kurs yaratish',
    welcome: {
      title: "Darsly CRM'ga xush kelibsiz",
      subtitle: "Birinchi kursingizni ishga tushiramiz. Barcha qadamlar quyida, bu bir necha daqiqa vaqt oladi.",
      cta: 'Birinchi kursingizni yarating',
      step1Desc: 'Nomi, darajasi va narxini kiriting.',
      step2Title: "O'quv dasturini tuzing",
      step2Desc: "Modullar, darslar va videolar qo'shing.",
      step3Title: "Test qo'shing",
      step3Desc: "O'quvchilar nimani o'rganganini tekshiring.",
      step4Title: 'Kursni nashr qiling',
      step4Desc: "O'quvchilar yozilishi uchun kursni faollashtiring.",
      step5Title: "Birinchi o'quvchilarni qo'shing",
      step5Desc: "O'quvchilarni taklif qiling va natijalarini kuzating.",
    },
    periods: {
      d7: '7 kun', d30: '30 kun', d90: '90 kun', y1: '12 oy',
    },
    quickActions: {
      title: 'Tezkor havolalar',
      courses: { label: 'Kurslar', desc: 'Katalogni boshqaring' },
      students: { label: "O'quvchilar", desc: "Ro'yxat va natijalar" },
      sales: { label: 'Sotuvlar', desc: 'Buyurtmalar' },
      inbox: { label: 'Xabarlar', desc: 'Xabarlar va fikrlar' },
      support: { label: "Qo'llab-quvvatlash", desc: 'Murojaatlar va javoblar' },
      calendar: { label: 'Kalendar', desc: 'Tadbirlar va eslatmalar' },
    },
    metrics: {
      students: { title: "To'lov qilgan o'quvchilar", change: 'Barcha vaqt' },
      orders: { title: 'Buyurtmalar', change: 'Yakunlangan, barcha vaqt' },
      revenue: { title: 'Daromad', change: "So'mda, barcha vaqt" },
      courses: { title: 'Kurslar', change: 'Hisobingizdagi kurslar' },
    },
    pulse: {
      title: "O'quvchilar hozir",
      total: "Jami {count} ta o'quvchi",
      updated: 'Yangilandi: {time}',
      tashkentTime: 'Toshkent vaqti',
      openDirectory: "Ro'yxatni ochish",
      onlineNow: 'Hozir onlayn',
      activeToday: 'Bugun faol',
      inactive7d: '7+ kun faol emas',
      atRisk: 'Xavf ostida',
    },
    revenueOverview: 'Daromad',
    revenueSub: 'Yakunlangan sotuvlar',
    revenueError: "Daromad grafigini yuklab bo'lmadi",
    emptyRevenue: {
      title: "Bu davrda hali daromad yo'q",
      desc: 'Boshqa davrni tanlang yoki yangi buyurtmalarni kuting.',
    },
    topCourses: 'Top kurslar',
    topCoursesDesc: "Daromad bo'yicha",
    viewAll: 'Barchasi',
    noRevenueData: "Daromad ma'lumotlari hali yo'q.",
    untitledCourse: 'Nomsiz kurs',
    recentActivity: "So'nggi buyurtmalar",
    viewAllOrders: 'Barcha buyurtmalar',
    table: {
      student: "O'quvchi", when: 'Sana', amount: 'Summa', status: 'Holat',
    },
    provider: { PAYCOM: 'Payme', CLICK: 'Click' },
    emptyOrders: {
      title: "So'nggi buyurtmalar yo'q",
      desc: "Yangi buyurtmalar shu yerda avtomatik paydo bo'ladi.",
    },
  },
};

export default dashboard;
